'use client'

import React from 'react';
import { toast } from './use-toast';

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
    toast({
      title: 'An error occurred',
      description: error.message,
      variant: 'destructive',
    });
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;